import {ButtonGroup} from '@kit';

import React from 'react';

import {Ability, SourceBook} from '../../../generated/types';
import {enumList, Filters, FiltersPopup} from '../../../components/filters';
import {abilityToString, sourceBookToString} from '../../../components/enums';

const ABILITIES = [
	Ability.Strength,
	Ability.Dexterity,
	Ability.Constitution,
	Ability.Wisdom,
	Ability.Intelligence,
	Ability.Charisma,
];
const SOURCES = [SourceBook.XPHB, SourceBook.XDMG, SourceBook.AU, SourceBook.FRHoF, SourceBook.DDBD];

export const originFilters = {
	abilities: enumList('ability', ABILITIES),
	sources: enumList('source', SOURCES),
};

type Props = {
	filters: Filters<typeof originFilters>;
};

export const OriginFilters: React.FC<Props> = ({filters}) => (
	<FiltersPopup filters={filters} header="Фильтровать предыстории">
		<li>
			<ButtonGroup
				items={ABILITIES}
				itemToHtml={abilityToString}
				multiple
				label="Характеристики"
				{...filters.field('abilities')}
			/>
		</li>
		<li>
			<ButtonGroup
				items={SOURCES}
				itemToHtml={sourceBookToString}
				multiple
				label="Источник"
				{...filters.field('sources')}
			/>
		</li>
	</FiltersPopup>
);
